/**
 * Cover art component with graceful fallback to a musical-note placeholder
 * when the /api/v1/tracks/:id/cover endpoint fails or returns nothing.
 */
import { useState } from "react";
import type { Track } from "@memes/shared";
import { tracksApi } from "../lib/api";
import { Music2 } from "lucide-react";

interface Props {
  track?: Track;
  className?: string;
  rounded?: string;
}

export const CoverImg: React.FC<Props> = ({ track, className = "", rounded = "rounded-xl" }) => {
  const [ok, setOk] = useState(true);
  if (!track || !ok) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 dark:bg-gray-800 text-gray-400 ${rounded} ${className}`}
      >
        <Music2 className="h-1/2 w-1/2" />
      </div>
    );
  }
  return (
    <img
      src={tracksApi.coverUrl(track.id)}
      alt={track.metadataTitle ?? track.name}
      loading="lazy"
      onError={() => setOk(false)}
      className={`object-cover ${rounded} ${className}`}
    />
  );
};
